import request from '@/utils/request'

/**
 * @description 获取用户汇报基础信息，是否有权限及是否已提交
 * @returns
 */
export function getReportAuthInfo() {
  return request.post('/phalapi/public/?service=Reporting.User.Info')
}

/**
 * @description 获取模板列表
 * @returns
 */
export function getTemplateList() {
  return request.post('/phalapi/public/?service=Reporting.ReportTemplate.List')
}

/**
 * @description 保存模板信息
 * @param {*} data
 * @returns
 */
export function saveTemplateInfo(data) {
  return request.post('/phalapi/public/?service=Reporting.ReportTemplate.Edit', data)
}

/**
 * @description 获取人员管理列表
 * @param {*} data
 * @returns
 */
export function getMemberList(data) {
  return request.post('/phalapi/public/?service=Reporting.ReporterConfig.List', data)
}

/**
 * @description 保存人员配置
 * @param {*} data
 * @returns
 */
export function saveMemeberSetting(data) {
  return request.post('/phalapi/public/?service=Reporting.ReporterConfig.Save', data)
}

/**
 * @description 获取汇报列表
 * @param {*} data
 * @returns
 */
export function getReportList(data) {
  return request.post('/phalapi/public/?service=Reporting.Report.List', data)
}

/**
 * @description 获取汇报详情
 * @param {*} data
 * @returns
 */
export function getReportInfo(data) {
  return request.post('/phalapi/public/?service=Reporting.Report.GetInfo', data)
}

/**
 * @description 提交汇报
 * @param {*} data
 * @returns
 */
export function saveReportInfo(data) {
  let url = '/phalapi/public/?service=Reporting.Report.Add'
  if (data.id) {
    url = '/phalapi/public/?service=Reporting.Report.Edit'
  }
  return request.post(url, data)
}

/**
 * @description 添加评论
 * @param {*} data
 * @returns
 */
export function addReportReply(data) {
  return request.post('/phalapi/public/?service=Reporting.ReportComment.Add', data)
}

/**
 * @description 删除评论
 * @param {*} data
 * @returns
 */
export function deleteReply(data) {
  return request.post('/phalapi/public/?service=Reporting.ReportComment.Remove', data)
}

/**
 * @description 获取汇报开关状态
 * @param {*} data
 * @returns
 */
export function getReportState(data) {
  return request.post('/phalapi/public/?service=Reporting.Configuration.GetStatus', data)
}

/**
 * @description 保存汇报推送开关状态
 * @param {*} data
 * @returns
 */
export function saveReportState(data) {
  return request.post('/phalapi/public/?service=Reporting.Configuration.Save', data)
}

/**
 * @description 修改汇报精选状态
 * @param {*} data
 * @returns
 */
export function changeReportStar(data) {
  return request.post('/phalapi/public/?service=Reporting.Report.Selected', data)
}

/**
 * @description 修改汇报问题采纳状态
 * @param {*} data
 * @returns
 */
export function changeReportAdopt(data) {
  return request.post('/phalapi/public/?service=Reporting.Report.Adopt', data)
}
/**
 * @description 获取批评表扬
 * @param {*} data
 * @returns
 */
export function getFeedBackList(data) {
  return request.post('/phalapi/public/?service=App.HrmFeedback.getFeedbackList', data)
}
